export default {
  login: { method: 'post', url: '/address/login' },
  index: { method: 'get', url: '/address/index' },
  userInfo: { method: 'get', url: '/address/info' }
}
